module.exports = {
          srcSet: __webpack_public_path__ + "3fa3ffe16ff9597133189d1afdf1960d-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "3fa3ffe16ff9597133189d1afdf1960d-2336.png",width: 2336,height: 468}],
          src: __webpack_public_path__ + "3fa3ffe16ff9597133189d1afdf1960d-2336.png",
          toString:function(){return __webpack_public_path__ + "3fa3ffe16ff9597133189d1afdf1960d-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AHIoiP2ANZX/fC+X/oM9pP9xMaT/XDir/4Zp1/9reeL+eGa6/zlmwPsARxxz/Uche/9BIoH+PSyM/zgykf8rSqH/IXvG/zKG0v6Ym7D/aG+n+z2ZLeejyescAAAAAElFTkSuQmCC",
          width: 2336,
          height: 468
        }